import { render } from "./CrmTaskModal.vue?vue&type=template&id=316287d7&scoped=true&ts=true&lang=pug"
import script from "./CrmTaskModal.vue?vue&type=script&lang=ts"
export * from "./CrmTaskModal.vue?vue&type=script&lang=ts"

import "./CrmTaskModal.vue?vue&type=style&index=0&id=316287d7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316287d7"]])

export default __exports__